<template>

  <el-dialog
    class="form-modal"
    :visible.sync="visible"
    :show-close="false"
    :close-on-click-modal="false"
    :modal="true"
  >

    <h2 class="form-section-header">
      Select payment method:
    </h2>

    <el-select
      v-model="accountId"
      placeholder="Select method"
    >
    <template slot="prefix">
      Method
    </template>
     <el-option
      v-for="(item, index) in paymentOptions"
      :key="index"
      :value="item.id"
      :label="`${item.name} ${item.accountNumber || item.number}`"
     />
    </el-select>

    <div class="inline-form-group" style="justify-content: flex-end;">
      <el-button
        @click="handleCancel"
      >
        Cancel
      </el-button>
      <el-button
        @click="updateAutoPay"
      >
        Submit
      </el-button>
    </div>


  </el-dialog>

</template>


<script>

export default {
  name: "AutoPaySelect",
  props: {
    visible: {required: true},
    cards: {required: true},
    banks: {required: true}
  },
  data() {
    return {
      accountId: "",
      paymentOptions: [],
    }
  },

  watch: {
    visible() {
      this.paymentOptions = [
        ...this.cards.filter(item => item.default),
        ...this.banks.filter(item => item.default)
      ]
    }
  },

  methods: {
    updateAutoPay(){

      if(!this.accountId){
        this.$notify({
          title: "Invalid selection",
          message: "Select a payment method",
          type: "error"
        })
        return;
      }

      this.$emit('optionSelected', this.accountId);
      this.accountId = "";
    },

    handleCancel(){
      this.$emit('closed');
      this.accountId = "";
    }
  }

}

</script>
